/**
 * @returns initData as JSON;
 * Default
 */
const initData = () => {
    if (!window.initData) {
        const initDataEL = document.getElementById('init-data');
        if (initDataEL) {
            const ID = initDataEL.innerHTML;
            return JSON.parse(ID);
        } else {
            return null;
        }
    } else {
        return window.initData;
    }
};

/**
 * Get Init Data;
 */
export const getInitData = initData;

export default new initData();



// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/packages/init-data.js